@if (type === 'ResolutionCentreMessage') {
    <div class="notification-message" [ngClass]="{'seen': seen}">
        <a routerLink="/resolution-center" (click)="markNotificationSeen.emit(notification_id)">
            <span class="avatar"></span>
            <span class="noth-header">New message in resolution center</span>
            <span>Lean On Support sent you a message</span>
            <span>{{ timestamp | dateFormat}}</span>
        </a>
    </div>
} @else if (type === 'ChatMessage') {
    <div class="notification-message" [ngClass]="{'seen': seen}">
        @if (!suspended) {
            <a routerLink="/client-messages/{{ id }}" (click)="markNotificationSeen.emit(notification_id)">
                <span class="avatar"></span>
                <span class="noth-header">New client message</span>
                <span>{{ sender }} sent you a message</span>
                <span>{{ timestamp | dateFormat}}</span>
            </a>
        } @else {
            <span class="suspended">
                <span class="avatar"></span>
                <span class="noth-header">New client message</span>
                <span>{{ sender }} sent you a message</span>
                <span>{{ timestamp | dateFormat}}</span>
            </span>
        }
    </div>
} @else if (type === 'GroupChatMessage') {
    <div class="notification-message" [ngClass]="{'seen': seen}">
        @if (!suspended) {
            <a routerLink="/chat-rooms" (click)="markNotificationSeen.emit(notification_id)">
                <span class="avatar"></span>
                <span class="noth-header">{{ title }}</span>
                <span>{{ message }}</span>
                <span>{{ timestamp | dateFormat}}</span>
            </a>
        } @else {
            <span class="suspended" (click)="markNotificationSeen.emit(notification_id)">
                <span class="avatar"></span>
                <span class="noth-header">{{ title }}</span>
                <span>{{ message }}</span>
                <span>{{ timestamp | dateFormat}}</span>
            </span>
        }
    </div>
} @else if (type == 'GroupChatObjection') {
    <div class="notification-message" [ngClass]="{'seen': seen}">
        @if (!suspended) {
            <a routerLink="/reported-messages/edit/{{ id }}" (click)="markNotificationSeen.emit(notification_id)">
                <span class="avatar"></span>
                <span class="noth-header">{{ title }}</span>
                <span>{{ message }}</span>
                <span>{{ timestamp | dateFormat}}</span>
            </a>
        } @else {
            <span class="suspended">
                <span class="avatar"></span>
                <span class="noth-header">{{ title }}</span>
                <span>{{ message }}</span>
                <span>{{ timestamp | dateFormat}}</span>
            </span>
        }
    </div>
} @else if (type === 'ScheduledEvent') {
    <div class="notification-message" [ngClass]="{'seen': seen}">
        @if (!suspended) {
            <a routerLink="/scheduler/calendar/{{type | lowercase}}/{{id}}" (click)="markNotificationSeen.emit(notification_id)">
                <span class="avatar"></span>
                <span class="noth-header">{{ title }}</span>
                <span>{{ sender }} scheduled new event on</span>
                <span>{{ timestamp | dateFormat}}</span>
            </a>
        } @else {
            <span class="suspended">
                <span class="avatar"></span>
                <span class="noth-header">{{ title }}</span>
                <span>{{ sender }} scheduled new event on</span>
                <span>{{ timestamp | dateFormat}}</span>
            </span>
        }
    </div>
} @else if (type == 'LiveEvent') {
    <div class="notification-message" [ngClass]="{'seen': seen}">
        @if (!suspended) {
            <a routerLink="/live-events" (click)="markNotificationSeen.emit(notification_id)">
                <span class="avatar"></span>
                <span class="noth-header">New live event</span>
                <span>{{ sender }} created new live event</span>
                <span>{{ timestamp | dateFormat}}</span>
            </a>
        } @else {
            <span class="suspended">
                <span class="avatar"></span>
                <span class="noth-header">New live event</span>
                <span>{{ sender }} created new live event</span>
                <span>{{ timestamp | dateFormat}}</span>
            </span>
        }
    </div>
} @else if (type === 'LiveEventStart') {
    <div class="notification-message" [ngClass]="{'seen': seen}">
        @if (!suspended) {
            <a routerLink="/live-events" (click)="markNotificationSeen.emit(notification_id)">
                <span class="avatar"></span>
                <span class="noth-header">Upcoming event</span>
                <span>Event scheduled on <code>DATE</code> at <code>TIME</code> starts in <code>SOME HOURS</code></span>
                <span>{{ timestamp | dateFormat}}</span>
            </a>
        } @else {
            <span class="suspended">
                <span class="avatar"></span>
                <span class="noth-header">Upcoming event</span>
                <span>Event scheduled on <code>DATE</code> at <code>TIME</code> starts in <code>SOME HOURS</code></span>
                <span>{{ timestamp | dateFormat}}</span>
            </span>
        }
    </div>
} @else if (type == 'QuestionnaireResponseFilled') {
    <div class="notification-message" [ngClass]="{'seen': seen}">
        <a routerLink="/user/user/details/{{id}}/questionnaire" (click)="markNotificationSeen.emit(notification_id)">
            <span class="avatar"></span>
            <span class="noth-header">Questionnaire filled out</span>
            <span>{{ message }}</span>
            <span>{{ timestamp | dateFormat}}</span>
        </a>
    </div>
} @else if (type == 'NoSuitableProgramFound') {
    <div class="notification-message" [ngClass]="{'seen': seen}">
        <a routerLink="/user/user/details/{{id}}/questionnaire" (click)="markNotificationSeen.emit(notification_id)">
            <span class="avatar"></span>
            <span class="noth-header">{{ title }}</span>
            <span>{{ message }}</span>
            <span>{{ timestamp | dateFormat}}</span>
        </a>
    </div>
} @else if (type == 'FeedPostCommentPosted') {
    <div class="notification-message" [ngClass]="{'seen': seen}">
        <a routerLink="review/comment" (click)="markNotificationSeen.emit(notification_id)">
            <span class="avatar"></span>
            <span class="noth-header">{{ title }}</span>
            <span>{{ message }}</span>
            <span>{{ timestamp | dateFormat}}</span>
        </a>
    </div>
}
